import { Typography } from "@mui/material";

interface IProps {
    name: string;
}
export const NewProject: React.FC<IProps> = ({name}) => <Typography>{name} a été crée avec succès</Typography>